import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { StyledButton } from "@insite/mobius/Clickable";
import getColor from "@insite/mobius/utilities/getColor";
import Button, { ButtonWrapper } from "@waytek/MobiusOverrides/Button/Button";
import { FormFieldStyle } from "@waytek/MobiusOverrides/FormField/FormField";
import Search from "@waytek/MobiusOverrides/Icons/Search";
import { colorPalette, colorStrings, fontFamilyAlt } from "@waytek/Utilities/variables";
import { css } from "styled-components";

searchWithinStyles.titleText = {
    ...searchWithinStyles.titleText,

    size: 18,
    lineHeight: 1.61,
    weight: "normal",
    fontFamily: fontFamilyAlt,
};

searchWithinStyles.wrapper = {
    ...searchWithinStyles.wrapper,

    css: css`
        ${FormFieldStyle} {
            margin-top: 10px;
        }
    `,
};

searchWithinStyles.searchTextField = {
    ...searchWithinStyles.searchTextField,

    mergeCss: true,
    iconProps: {
        src: Search,
        color: colorStrings.commonGlobalWhite,

        css: css`
            &&& {
                background-color: ${getColor(colorStrings.secondaryMain)};
                border-radius: 0;
                padding: 10px;
                top: 0;
                right: 0;
                width: 40px;
                height: 40px;

                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        `,
    },
    css: css`
        padding-right: 45px !important;
    `,
};
